import React from "react";
import {Card} from "react-bootstrap";
import {UniCol, UniSpinner} from "../../../../@WUM/core/Elements";
import {ResponseNotificationSettings} from "../../API/response/settingstimetracking";

interface TimeTrackingDashboardWidgetProps {
}

const TimeTrackingDashboardWidget = (props: TimeTrackingDashboardWidgetProps) => {

    const settings = ResponseNotificationSettings()


    if (!settings || typeof settings === "undefined" || typeof settings === "boolean") return <><UniSpinner/></>;

    const now = new Date();
    const start = new Date(settings.startDateDashboardInfoBanner);
    const end = new Date(settings.endDateDashboardInfoBanner);

    const isActive =
        !isNaN(start.getTime()) &&
        !isNaN(end.getTime()) &&
        now >= start &&
        now <= end;

    if (!isActive) {
        return null;
    }

    return (
        <>
            <UniCol xs={12} class={"mb-3"} >
                <Card className="w-100 card">
                    <Card.Header>
                        {settings.dashboardInfoBannerHeadline}
                    </Card.Header>
                    <Card.Body>
                        <div className="clock-timing border rounded shadow-sm p-4">
                            <div
                                dangerouslySetInnerHTML={{__html: settings.dashboardInfoBannerContent}}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </UniCol>
        </>
    );
};

export default TimeTrackingDashboardWidget;
